"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiChip = getMuiChip;
function getMuiChip(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      outlined: {
        '&:active': {
          boxShadow: 'none'
        },
        '&:hover': {
          '&.MuiChip-clickable': {
            backgroundColor: palette.grey[50]
          },
          '.MuiChip-deleteIcon': {
            '&.MuiChip-badge': {
              backgroundColor: palette.common.white,
              color: palette.common.black
            },
            color: palette.common.black
          },
          '.MuiChip-icon': {
            color: palette.common.black,
            margin: '0 6px 0 0'
          },
          '.MuiChip-label': {
            color: palette.common.black,
            fontSize: '12px',
            fontWeight: 400
          },
          backgroundColor: palette.grey[50],
          border: "1px solid ".concat(palette.grey[300]),
          color: palette.common.black
        },
        '.MuiChip-deleteIcon': {
          '&.MuiChip-badge': {
            alignItems: 'center',
            backgroundColor: palette.grey[100],
            borderRadius: '4px',
            color: palette.common.black,
            display: 'flex',
            fontSize: '12px',
            height: '16px',
            justifyContent: 'center',
            padding: '0 8px',
            width: '37px'
          },
          '&:hover': {
            '&.MuiChip-badge': {
              color: palette.common.black
            },
            color: palette.common.black
          },
          color: palette.grey[600],
          fontSize: '18px',
          margin: '0 0 0 8px'
        },
        '.MuiChip-icon': {
          color: palette.grey[600],
          margin: '0 6px 0 0'
        },
        '.MuiChip-label': {
          color: palette.common.black,
          fontSize: '12px',
          fontWeight: 400
        },
        backgroundColor: palette.common.white,
        border: "1px solid ".concat(palette.grey[300]),
        boxShadow: 'none',
        color: palette.common.white
      },
      root: {
        '&.Mui-disabled': {
          '&.MuiChip-clickable': {
            backgroundColor: palette.grey[50]
          },
          '.MuiChip-deleteIcon': {
            '&.MuiChip-badge': {
              backgroundColor: palette.grey[100],
              color: palette.grey[300]
            },
            color: palette.grey[300]
          },
          '.MuiChip-icon': {
            color: palette.grey[300],
            margin: '0 6px 0 0'
          },
          '.MuiChip-label': {
            color: palette.grey[300],
            fontSize: '12px',
            fontWeight: 400
          },
          backgroundColor: palette.grey[50],
          border: "1px solid ".concat(palette.grey[300]),
          boxShadow: 'none',
          opacity: 1
        },
        '&:active': {
          boxShadow: 'none'
        },
        '&:hover': {
          '&.MuiChip-clickable': {
            backgroundColor: palette.primary[50]
          },
          '.MuiChip-deleteIcon': {
            '&.MuiChip-badge': {
              backgroundColor: palette.primary[900],
              color: palette.primary[50]
            },
            color: palette.primary[900],
            fontSize: '18px',
            margin: '0 0 0 8px'
          },
          '.MuiChip-icon': {
            color: palette.primary[900],
            margin: '0 6px 0 0'
          },
          '.MuiChip-label': {
            color: palette.primary[900],
            fontSize: '12px',
            fontWeight: 400
          },
          backgroundColor: palette.primary[50],
          border: "1px solid ".concat(palette.primary[700]),
          boxShadow: 'none',
          color: palette.primary[700]
        },
        '.MuiChip-deleteIcon': {
          '&.MuiChip-badge': {
            alignItems: 'center',
            backgroundColor: palette.primary[900],
            borderRadius: '4px',
            color: palette.primary[50],
            display: 'flex',
            fontSize: '12px',
            height: '16px',
            justifyContent: 'center',
            padding: '0 8px',
            width: '37px'
          },
          color: palette.primary[900],
          fontSize: '18px',
          margin: '0 0 0 8px'
        },
        '.MuiChip-icon': {
          color: palette.primary[900],
          height: '14px',
          margin: '0 6px 0 0',
          width: '14px'
        },
        '.MuiChip-label': {
          color: palette.primary[900],
          fontSize: '12px',
          fontWeight: 400,
          padding: 0,
          textOverflow: 'clip'
        },
        backgroundColor: palette.primary[50],
        border: "1px solid ".concat(palette.primary[700]),
        boxShadow: 'none',
        color: palette.primary[700],
        height: '32px',
        padding: '8px 12px'
      }
    }
  };
}